module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-buttons"
  }, [(_vm.musicOn) ? _c('div', {
    staticClass: "musicIcon"
  }, [_c('span', {
    on: {
      "click": _vm.setMusic
    }
  }, [_c('i', {
    staticClass: "fa fa-music fa-lg"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.volume),
      expression: "volume",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "id": "volumeSlider"
    },
    domProps: {
      "value": (_vm.volume)
    },
    on: {
      "__r": function($event) {
        _vm.volume = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _c('div', {
    staticClass: "musicIcon"
  }, [_c('span', {
    staticClass: "fa-stack fa-lg",
    on: {
      "click": _vm.setMusic
    }
  }, [_c('i', {
    staticClass: "fa fa-music fa-stack-1x"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ban fa-stack-2x"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "round-counter"
  }, [_c('span', {
    attrs: {
      "id": "tiny"
    }
  }, [_vm._v("Round")]), _vm._v("\n        " + _vm._s(_vm.round) + "\n      ")]), _vm._v(" "), (['pass1', 'pass2'].includes(_vm.phase) && _vm.canCancel) ? _c('div', [_c('button', {
    staticClass: "btn btn-default line",
    on: {
      "click": function($event) {
        return _vm.menu('CPT')
      }
    }
  }, [_vm._v("Cancel"), _c('br'), _vm._v("Passing")])]) : _c('div', {
    staticClass: "dropdown"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "btn-default",
    on: {
      "click": function($event) {
        return _vm.menu('EG')
      }
    }
  }, [_vm._v("Exit Game")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn-default",
    on: {
      "click": function($event) {
        return _vm.menu('SG')
      }
    }
  }, [_vm._v("Save Game")])]), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.canTurnInCards
    }
  }, [_c('a', {
    staticClass: "btn-default",
    on: {
      "click": function($event) {
        return _vm.menu('TIC')
      }
    }
  }, [_vm._v("Turn In Cards")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn-default",
    on: {
      "click": function($event) {
        return _vm.menu('SMC')
      }
    }
  }, [_vm._v("See my Cards")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn-default",
    on: {
      "click": function($event) {
        return _vm.menu('Set')
      }
    }
  }, [_vm._v("My Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn-default",
    on: {
      "click": function($event) {
        return _vm.menu('PI')
      }
    }
  }, [_vm._v("Players Info")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn-default",
    on: {
      "click": function($event) {
        return _vm.menu('AIS')
      }
    }
  }, [_vm._v("Change AI Speed")])])])]), _vm._v(" "), _c('div', [(_vm.player.isBot && _vm.paused) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "id": "endTurnButton"
    },
    on: {
      "click": function($event) {
        return _vm.menu('PAI')
      }
    }
  }, [_vm._v("Resume AI")]) : (_vm.player.isBot && !_vm.paused) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "id": "endTurnButton"
    },
    on: {
      "click": function($event) {
        return _vm.menu('PAI')
      }
    }
  }, [_vm._v("Pause AI")]) : _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.phase === 'initialTroops',
      "id": "endTurnButton"
    },
    on: {
      "click": function($event) {
        return _vm.menu('ET')
      }
    }
  }, [_vm._v("End Turn")])])]), _vm._v(" "), _c('ul', {
    staticClass: "info"
  }, [_c('li', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('strong', [_vm._v("Current Player:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "flex"
    }
  }, [_vm._v(" " + _vm._s(_vm.player.name)), _c('icon', {
    attrs: {
      "code": _vm.player.code,
      "size": 18,
      "id": "icon"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Territories: ")]), _vm._v(_vm._s(_vm.player.terrCount))]), _vm._v(" "), (_vm.phase === 'initialTroops') ? _c('li', [_c('strong', [_vm._v("Total Troops: ")]), _vm._v(_vm._s(_vm.player.reserves))]) : _c('li', [_c('strong', [_vm._v("Troops: ")]), _vm._v(_vm._s(_vm.player.reserves))]), _vm._v(" "), (_vm.phase === 'initialTroops') ? _c('li', [_c('strong', [_vm._v("Troops: ")]), _vm._v(_vm._s(_vm.player.tempReserves))]) : _c('li', [_c('strong', [_vm._v("Attack: ")]), _vm._v(_vm._s(_vm.attackLine))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Menu\n        "), _c('span', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47dc3ef8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 198
// module chunks = 0